import { getAuthContext } from '../context/AuthContext';

const getAxios = () => getAuthContext().axiosInstance;

export const DevolucionService = {
    getAll: async (idEmpresa = 1) => {
        const response = await getAxios().get(`/api/devoluciones/empresa/${idEmpresa}`);
        return response.data?.data ?? [];
    },
    
    getById: async (id) => {
        const response = await getAxios().get(`/api/devoluciones/${id}`);
        return response.data?.data;
    },

    create: async (devolucion) => {
        const response = await getAxios().post('/api/devoluciones', devolucion);
        return response.data?.data;
    },

    getByVenta: async (idVenta) => {
        const response = await getAxios().get(`/api/devoluciones/venta/${idVenta}`);
        return response.data?.data ?? [];
    }
};
